import { Transform, Type } from 'class-transformer';

import { dateTransform } from '../utils/helper';
import { InsModDate } from './date.model';
import { Offer } from './offer.model';

export class Contatto extends InsModDate {
	id!: number;
	hqid!: number;
	lastoperatorid?: number;
	status?: string;
	category?: ContactCategory;
	offerct?: number;
	offeravg?: number;
	name?: string;
	surname?: string;
	co?: string;
	@Transform(dateTransform)
	birthdate?: Date;
	address?: string;
	streetno?: string;
	city?: string;
	province?: string;
	comune?: string;
	zipcode?: string;
	landline?: string;
	mobile?: string;
	email?: string;
	preferredpaymentmethod?: string;
	preferredtime?: string;
	@Type(() => Offer)
	ultimaOfferta?: Offer;

	get fullname() {
		return `${this.name} ${this.surname ? this.surname : ''}`;
	}

	get fulladdress() {
		return `${this.address} ${this.streetno ? this.streetno : ''} ${this.city ? ', ' + this.city : ''}`;
	}
}

export enum ContattoStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive'
}

export enum ContactCategory {
	NEW = 'new',
	PORTFOLIO = 'portfolio',
	DORMIENT = 'dormient',
}